<template lang="pug">
.study-list-table
  template(v-for='list in studyList')
    .study-list-table__head.font-bold.text-large
      .study-list-table__head__title {{ list.title }}
    table-base.study-list-table__table
      table-row-base.study-list-table__table__row-header
        table-header-base.study-list-table__table__row-header__cell
          slot(name='subjectHeader')
        table-header-base.study-list-table__table__row-header__cell
          slot(name='sUnitHeader')
        table-header-base.study-list-table__table__row-header__cell
          slot(name='lastMinuteCheckHeader')
        table-header-base.study-list-table__table__row-header__cell
          slot(name='resolveHeader')
      table-row-base.study-list-table__table__row(v-for='(item, index) in list.items', :key='index')
        table-data-base.study-list-table__table__row__cell.align-center {{ item.subjectName }}
        table-data-base.study-list-table__table__row__cell.align-center {{ item.sUnitName }}
        table-data-base.study-list-table__table__row__cell.align-center
          button-secondary.study-list-table__table__row__cell__button(
            v-if='item.isLastMinuteCheckLearned',
            :data-disabled='!item.lastMinuteCheckSUnitId',
            @click='buttonEvent(item, list.title, sUnitCategorySetting.LAST_MINUTE_CHECK)'
          )
            slot(name='learnedLabel')
          button-primary.study-list-table__table__row__cell__button(
            v-else,
            :data-disabled='!item.lastMinuteCheckSUnitId',
            @click='buttonEvent(item, list.title, sUnitCategorySetting.LAST_MINUTE_CHECK)'
          )
            slot(name='notLearnedLabel')
        table-data-base.study-list-table__table__row__cell.align-center
          button-secondary.study-list-table__table__row__cell__button(
            v-if='item.isResolveLearned',
            :data-disabled='!(item.isResolveCsvExist && item.resolveSUnitId)',
            @click='buttonEvent(item, list.title, sUnitCategorySetting.RESOLVE)'
          )
            slot(name='learnedLabel')
          button-primary.study-list-table__table__row__cell__button(
            v-else,
            :data-disabled='!(item.isResolveCsvExist && item.resolveSUnitId)',
            @click='buttonEvent(item, list.title, sUnitCategorySetting.RESOLVE)'
          )
            slot(name='notLearnedLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import ButtonSecondary from '@/components/molecules/student/ButtonSecondary.vue'
import { StudyItemListType } from '@/models/studyListModel'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * テスト一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ButtonPrimary,
    ButtonSecondary,
  },
})
export default class StudyListTable extends Vue {
  // テスト一覧表示情報
  @Prop()
  studyList!: StudyItemListType[]

  // ボタン押下時イベント
  @Prop()
  buttonEvent!: Function

  // カテゴリー定義情報
  private get sUnitCategorySetting(): SUnitCategorySetting {
    return SUnitCategorySetting
  }
}
</script>

<style lang="stylus" scoped>
.study-list-table
  &__head
    display flex
    padding 5px
    background-color var(--color-study-list-head__background)
    color var(--color-study-list-head__text)

  &__table
    width 100%

    &__row-header
      background-color var(--color-study-list-subhead__background)
      color var(--color-study-list-subhead__text)

    &__row, &__row-header
      &__cell
        width 25%
        padding 10px
        border 1px solid var(--color-study-list-table__border)
</style>
